controllers.controller('BankTransferController', [
    '$scope', '$state', 'constants', 'LocaleService', 'Storage', 'UserService', '$ionicLoading', 'API',
    function ($scope, $state, Const, LocaleService, Storage, UserService, $ionicLoading, API) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.user = UserService.get();
        $scope.paymentMethods = Storage.get('paymentMethods') || [];
        $scope.showAmountSelect = true;
        $scope.constants = Const;
        $scope.depositValue = Storage.get('depositValue');
        $scope.method = $state.params.method || '';
        $scope.pspCurrencies = $scope.method.pspCurrencies || [];
        $scope.pspCurrency = $scope.pspCurrencies.length > 0 ? $scope.pspCurrencies[0] : null;
        $scope.config = {
            min: $scope.depositValue.minimum,
            max: $scope.depositValue.maximum,
            visual: $scope.depositValue.visual,
            digits: 0,
            step: 50,
            listAmounts: [],
            pspCurrencies: $scope.pspCurrencies
        };

        // Bank transfer
        $scope.defaultBankDetails = Const.wiretransferDetails || {
            beneficiary_name: '',
            beneficiary_address: '',
            beneficiary_bank: '',
            bank_address: '',
            beneficiary_account_number: '',
            beneficiary_iban: '',
            swift: '',
            comments: ''
        };
        $scope.customBankDetails = Const.bankTransferCustomBankDetails;

        var result = [];
        Array(5).fill(null).reduce(function (acc, cur, index) {
            var tmp = Math.ceil(acc * Const.depositMultipliers[index]);
            result.push(tmp);
            return tmp;
        }, $scope.config.visual <= $scope.config.min ? $scope.config.min : $scope.config.visual);

        if (result.length > 0) $scope.config.listAmounts = result;

        $scope.amount = {
            value: $scope.config.visual,
            pspCurrency: $scope.pspCurrency
        };

        $scope.modal = {
            actionText: LocaleService.translation.try_again,
            state: false
        };

        $scope.pendingDepositMessage = $scope.translation['pendingDepositMessage'] &&
            $scope.translation['pendingDepositMessage'].replace('${clientName}', [$scope.user.firstName, $scope.user.lastName].join(' '))
            || 'Please contact support';

        $scope.createPendingDeposit = function(){

            if(!Const['bankTransferCreatePendingDeposit']) return;

            function checkResponse(data) {
                if (data.status !== 1) {
                    throw new ErrorService({
                        source: 'BankTransferController',
                        type: Const.error.type.VALIDATION,
                        code: data.code,
                        severity: 'warning',
                        data: {response: data}
                    });
                }
                return data;
            }

            var request = {
                type: 'Deposit',
                amount: $scope.amount.value,
                paymentMethod: $scope.translation[$scope.method.name] || $scope.method.name
            };

            $ionicLoading.show();

            return API.pendingDeposit(request)
                .then(checkResponse)
                .then(function (response) {
                    $ionicLoading.hide();
                })
                .catch(function (error) {
                    $ionicLoading.hide()
                    $scope.showMessage = true;
                    $scope.modal.textTitle = LocaleService.translation.messages.pending;
                    $scope.modal.isError = true;
                    $scope.modal.textContent = $scope.pendingDepositMessage;
                    $scope.modal.actionText = LocaleService.translation.close;
                    $scope.modal.back = $scope.paymentMethods.length > 1 ? 'root.app.wallet' : 'root.app.assets';
                    $scope.modal.state = true;
                })
        }

        $scope.$on('$ionicView.beforeEnter', function () {
            if($scope.method.hasOwnProperty("amountRequired") && !$scope.method.amountRequired)  {
                $scope.showAmountSelect = false;
                $scope.amount.value = 1;
            }
        });

    }]);
